// ------------------- Global variables -------------------
export const VERSION = "0.1.0.1";
export let historyStack: string[] = [];
export let redoStack: string[] = [];
export const historyLimit = 50;
export const DISPLAY_URL = "display.html";